import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private _permissions: Array<string>;
  private _jetbridgePermissions: Array<string>
  canViewUserManagement: boolean;

  constructor(
        public authService: AuthService 
  ) { 
  }

    filterJetbridgePermissions() : Array<string> | null {
      let jetbridgePermissions: Array<string> = [];
      let specificPermissions: Array <string> = [];

      this._permissions.forEach(productPermission => {
        if (productPermission.includes('JetBridge')) {
          jetbridgePermissions.push(productPermission);
        }
      });

      if (jetbridgePermissions === undefined || jetbridgePermissions.length === 0){
        return
      }

      jetbridgePermissions.forEach(permission => {
        //Format AfirsAnalytics:All
        specificPermissions.push(permission.split(":")[1]);
      })

      return specificPermissions;
    }

        // Objective here is to provide a function that can be used by n amount of components,
    // to retrieve whether a component, or item within a template should be shown. 
    // The service will be injected as a singleton, with the BehaviorSubject, defaulting to
    // false. Once the permissions are retrieved and updated from the auth service, the next
    // value is emitted to the BehaviorSubject, with shareRepaly, allowing late subscribers 
    // to capture the last result and sharing the instance of the subject. 
    shouldShowItem(itemName: string): Observable<boolean> {
      let showItemStatusSubject$ = new BehaviorSubject<boolean>(false);
      
      this.authService.getUserPermissions().pipe(
        shareReplay({bufferSize:1, refCount: true}),
      ).subscribe(
        permissions => {
        if (permissions){
              this._permissions = permissions
              this._jetbridgePermissions = this.filterJetbridgePermissions();

            if (!this._jetbridgePermissions) {
              showItemStatusSubject$.next(false);
              return showItemStatusSubject$.asObservable();
            }

            if(this._jetbridgePermissions.includes(`${itemName}`)){
                showItemStatusSubject$.next(true);
              }else{
                showItemStatusSubject$.next(false);
              }

        }else{
          showItemStatusSubject$.next(false);
        }
      },
        err => {
          console.log(err);
        },
      );

      return showItemStatusSubject$.asObservable();
    }

    shouldAccessTab(tabName: string){
      if (!this._permissions) {
        let perm = JSON.stringify(this.authService.user.permissions);
        this._permissions = perm.split(",");
        this._jetbridgePermissions = this.filterJetbridgePermissions();
      }
      
      if(JSON.stringify(this._jetbridgePermissions).includes(`${tabName}`)){
          this.canViewUserManagement = true
        return true;
      }
      return false;
    }
}
